export default __webpack_public_path__ + "static/media/MATIC-USDC.d785aa49.png";